import { RemoteDataStore as BaseRemoteDataStore } from '@move-frontend/utils';
export class RemoteDataStore extends BaseRemoteDataStore {
    validateResponse(response) {
        if (!response || typeof response.data !== 'object') {
            throw new Error('Invalid response data');
        }
        return response;
    }
}
//# sourceMappingURL=RemoteDataStore.js.map